module.exports = __webpack_public_path__ + "img/logo_menubar_bw_wave.70d82dd8.svg";